// extracted by mini-css-extract-plugin
export var backButton = "_15-1";
export var content = "_15-d";
export var continueButton = "_15-7";
export var continueHint = "_15-8";
export var continueRow = "_15-6";
export var leftInner = "_15-0";
export var shell = "_15-e";
export var sidebarContent = "_15-5";
export var skipButton = "_15-c";
export var spacer = "_15-2";
export var spin = "_15-a";
export var spinner = "_15-9";
export var spinnerOverlay = "_15-b";
export var subtitle = "_15-4";
export var title = "_15-3";